import React from 'react'
import values from 'mout/object/values'
import sortByPropText from '../../../../helpers/content/manageSets/sortByPropText'
import HeatMarker from './HeatMarker'
import getSegmentHeats from '../../../../helpers/assessment/getSegmentHeats'

export default function MotivationBars ({byItem, assessmentSubtests}) {
  let heatMaps = []
  const olStyles = {
    english: {marginLeft: '51px', marginTop: '2px'},
    math: {marginLeft: '45px'},
    reading: {marginLeft: '57px'},
    science: {marginLeft: '45px'},
  }
  const divStyles = {
    english: {width: '60px'},
    math: {width: '72px'},
    reading: {width: '48px'},
    science: {width: '72px'},
  }
  const itemsPerSquare = {
    english: 15,
    math: 10,
    reading: 10,
    science: 7,
  }
  const subtests = sortByPropText(values(assessmentSubtests), 'index')
  subtests.forEach((subtest) => {
    let heatMarkers = []
    const subtestId = subtest.setId
    const nameLC = subtest.displayName.toLowerCase()
    const items = sortByPropText(values(byItem[subtestId]), 'index')
    const segmentHeats = getSegmentHeats(items, itemsPerSquare[nameLC])
    segmentHeats.forEach((segmentHeat) => {
      heatMarkers.push(
        <HeatMarker
          heat={segmentHeat.heat}
          itemNumber={segmentHeat.itemNumber}
          key={`mot${nameLC}${segmentHeat.itemNumber}`}
        />
      )
    })
    heatMaps.push(
      <ol className='heatMap' style={olStyles[nameLC]} key={`mot${nameLC}`}>
        <div className={`subjectBar ${nameLC}Bar`} style={divStyles[nameLC]}>{subtest.displayName}</div>
        {heatMarkers}
      </ol>
    )
  })



  return (
    <div className="skill-graphs ">
			<div className="reports">
        {heatMaps}
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/TestTaking/MotivationBars.js